module.exports = __webpack_public_path__ + "img/logo-light.c92032cc.svg";